var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"18 15 12 9 6 15","key":0}),React.createElement("title",{"id":"chevronUp","key":1},"Chevron Up")]);
}

ChevronUp.defaultProps = {"aria-labelledby":"chevronUp","role":"img","width":"16","height":"16","viewBox":"0 0 24 24","fill":"none","stroke":"#ff6000","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-chevron-up"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
